import { JSX } from 'react'

import {
  IDataProviderFilter,
  IFilter,
  IFilterOperator,
  Logic,
  Operator,
} from 'core-components/types'

export interface IAudienceEditRuleProps {
  value: number | string | null | string[]
  onChange: (value: number | string | string[]) => void
  condition: Operator | IFilterOperator
  className?: string
  disabled?: boolean
}

export interface IEditor {
  /**
   * List of operators for field
   */
  conditions: Operator[]
  /**
   *  Field editor
   */
  editor: (valueEditor: IAudienceEditRuleProps) => JSX.Element
}

export enum ESaveTriggerType {
  onChange = 'onChange',
  onSaveButtonClick = 'onSaveButtonClick',
}

export interface IDataProviderFilterProps {
  /**
   * A Class name for component root node
   */
  className?: string
  /**
   * Value for filter
   */
  value: IDataProviderFilter
  /**
   * Callback function fires when filter is changed
   */
  onChange: (value: IDataProviderFilter) => void
  /**
   * Editors for filter
   */
  editors: {
    [field: string]: IEditor
  }
  /**
   * An option for render filter without groups
   */
  withoutGroups?: boolean
  /**
   * An option for trigger
   */
  saveTrigger?: ESaveTriggerType
  /**
   * Optional content above the filter
   */
  headerContent?: () => JSX.Element
  /**
   * Allow user create custom field values
   */
  allowCreateFields?: boolean
}

export interface ICondition extends IFilter {
  id: string
}

export interface IGroup {
  id: string
  logic: Logic
  filters: Array<IGroup | ICondition>
}
